<template>
  <ModalDialog
    ref="dialog"
    title="Import Price List Template"
    submitTitle="Import"
    icon="fa-money-check-edit-alt"
    :submitDisabled="submitDisabled"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <Spinner v-if="loading" />
      <div v-if="!loading">
        <FormRow label="Price List Template">
          <FormSelect v-model="selectedTemplateId" :options="templateListLookup" />
        </FormRow>
      </div>
    </FormGroup>
  </ModalDialog>
</template>



<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'CustomerPriceListImportTemplateDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  data() {
    return {
      loading: false,
      dialogForm: {},
      templateList: [],
      selectedTemplateId: null,
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    templateListLookup() {
      return _.concat(
        [{ value: null, name: 'Select a Template' }], 
        _.map(this.templateList, (template) => {
          return {
            value: template.id,
            name: template.name
          }
        })
      )
    },
    submitDisabled() {
      return this.selectedTemplateId == null
    }
  },
  methods: {
    show() {
      // Reset form
      this.dialogForm = { }
      this.selectedTemplateId = null
      this.submitting = false

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.modalClosed(this.selectedTemplateId)
      this.hide()
    },
    requestData() {
      this.loading = true

      this.$apiService.pricingService.getPriceListTemplateList()
        .then((response) => {
          this.templateList = response.data
        })
        .catch(error => {
          this.displayNetworkError(error)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>